<template>
  <div id="contenedor-excel-extimaciones-ejercicio">
    <v-form
      ref="exportarExcelEstimacionesEjericio"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Estimaciones
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="seleccion"
            mandatory>
            <v-radio
              value="listadoActual">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Listado Actual</strong>
                </div>
              </template>
            </v-radio>
            <v-radio
              value="rangoFechas">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Rango de Fechas (de contrato)</strong>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-row v-if="seleccion === 'rangoFechas'">
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelEstimacionesEjercicio">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelEstimacionesEjercicio',
  mixins: [mixGenerarExceles],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
    contratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      seleccion: 'listadoActual',
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'ESTIMACIONES POR EJERCICIO',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        {
          value: 'Ejercicio', nombreColumna: 'ejercicioContrato', orden: 1,
        },
        {
          value: 'Número Contrato', nombreColumna: 'numeroContrato', orden: 2,
        },
        {
          value: 'Fecha de Presentación', nombreColumna: 'fechaPresentacion', orden: 3,
        },
        {
          value: 'Fecha de Autorizacion', nombreColumna: 'fechaAutorizacion', orden: 4,
        },
        {
          value: 'Financiado', nombreColumna: 'financiado', orden: 5,
        },
        {
          value: 'Número', nombreColumna: 'numero', orden: 6,
        },
        {
          value: 'Finiquito', nombreColumna: 'finiquito', orden: 7,
        },
        {
          value: 'Fecha Del', nombreColumna: 'fechaDel', orden: 8,
        },
        {
          value: 'Fecha Al', nombreColumna: 'fechaAl', orden: 9,
        },
        {
          value: 'Directo', nombreColumna: 'importeCostoDirecto', orden: 10,
        },
        {
          value: 'Indirectos', nombreColumna: 'importeCostoIndirectos', orden: 11,
        },
        {
          value: 'Utilidad', nombreColumna: 'importeUtilidad', orden: 12,
        },
        {
          value: 'Adicionales', nombreColumna: 'importeCargosAdicionales', orden: 13,
        },
        {
          value: 'Estimado', nombreColumna: 'importeEstimado', orden: 14,
        },
        {
          value: 'Amort. Ant.', nombreColumna: 'importeAmortizacionAnticipo', orden: 15,
        },
        {
          value: 'Subtotal', nombreColumna: 'subtotal', orden: 16,
        },
        {
          value: 'C. Financiero', nombreColumna: 'importeCostoFinanciero', orden: 17,
        },
        {
          value: 'Subtotal 2', nombreColumna: 'subtotalDos', orden: 18,
        },
        {
          value: 'IVA', nombreColumna: 'importeIva', orden: 19,
        },
        {
          value: 'Facturado', nombreColumna: 'totalFactura', orden: 20,
        },
        {
          value: 'Deducciones', nombreColumna: 'importeDeducciones', orden: 21,
        },
        {
          value: 'Retenido', nombreColumna: 'importeRetenido', orden: 22,
        },
        {
          value: 'Devuelto', nombreColumna: 'importeDevuelto', orden: 23,
        },
        {
          value: 'Sanción', nombreColumna: 'importeSancion', orden: 24,
        },
        {
          value: 'Ajuste', nombreColumna: 'importeBonificacion', orden: 25,
        },
        {
          value: 'Líquido', nombreColumna: 'importeLiquido', orden: 26,
        },
        {
          value: 'Estatus de Pago', nombreColumna: 'estatusPago', orden: 27,
        },
        {
          value: 'Fecha', nombreColumna: 'fechaPago', orden: 28,
        },
      ],
      noData: [{
        ejercicioContrato: '',
        numeroContrato: '',
        fechaPresentacion: '',
        fechaAutorizacion: '',
        financiado: '',
        numero: '',
        finiquito: '',
        fechaDel: '',
        fechaAl: '',
        importeCostoDirecto: '',
        importeCostoIndirectos: '',
        importeUtilidad: '',
        importeCargosAdicionales: '',
        importeEstimado: '',
        importeAmortizacionAnticipo: '',
        subtotal: '',
        importeCostoFinanciero: '',
        subtotalDos: '',
        importeIva: '',
        totalFactura: '',
        importeDeducciones: '',
        importeRetenido: '',
        importeDevuelto: '',
        importeSancion: '',
        importeBonificacion: '',
        importeLiquido: '',
        estatusPago: '',
        fechaPago: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelEstimacionesEjercicio() {
      const data = this.crearExcelEstimacionesEjercicio;
      await this.mixGenerarExcel(data);
    },
    getEstimaciones(contrato) {
      if (!contrato.estimaciones) return [];
      return contrato.estimaciones
        .slice()
        .sort((a, b) => Number(a.numero) - Number(b.numero))
        .map((estimacion) => ({
          ...estimacion,
          ejercicioContrato: {
            value: contrato.ejercicio,
            estilo: {
              ...this.estilos.centrado,
            },
          },
          numeroContrato: {
            value: contrato.numero,
            estilo: {
              ...this.estilos.centrado,
            },
          },
          fechaPresentacion: {
            value: estimacion.fechaPresentacion ? this.$moment(estimacion.fechaPresentacion).format('DD/MM/YYYY') : '',
            estilo: {
              ...this.estilos.centrado,
            },
          },
          fechaAutorizacion: {
            value: estimacion.fechaAutorizacion ? this.$moment(estimacion.fechaAutorizacion).format('DD/MM/YYYY') : '',
            estilo: {
              ...this.estilos.centrado,
            },
          },
          financiado: {
            value: contrato.esObraFinanciada ? 'Si' : 'No',
            estilo: {
              ...this.estilos.centrado,
            },
          },
          numero: {
            value: estimacion.numero,
            estilo: {
              ...this.estilos.centrado,
            },
          },
          finiquito: {
            value: estimacion.esEstimacionFiniquito ? 'Si' : '',
            estilo: {
              ...this.estilos.centrado,
            },
          },
          fechaDel: {
            value: this.$moment(estimacion.fechaDel).format('DD/MM/YYYY'),
            estilo: {
              ...this.estilos.centrado,
            },
          },
          fechaAl: {
            value: this.$moment(estimacion.fechaAl).format('DD/MM/YYYY'),
            estilo: {
              ...this.estilos.centrado,
            },
          },
          importeCostoDirecto: {
            value: estimacion.importeCostoDirecto,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCostoIndirectos: {
            value: estimacion.importeCostoIndirectos,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeUtilidad: {
            value: estimacion.importeUtilidad,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCargosAdicionales: {
            value: estimacion.importeCargosAdicionales,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimado: {
            value: estimacion.importeEstimado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAmortizacionAnticipo: {
            value: estimacion.importeAmortizacionAnticipo,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          subtotal: {
            value: estimacion.subtotal,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCostoFinanciero: {
            value: estimacion.importeCostoFinanciero,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          subtotalDos: {
            value: estimacion.subtotalDos,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeIva: {
            value: estimacion.importeIva,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          totalFactura: {
            value: estimacion.totalFactura,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeDeducciones: {
            value: estimacion.importeDeducciones,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeRetenido: {
            value: estimacion.importeRetenido,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeDevuelto: {
            value: estimacion.importeDevuelto,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeSancion: {
            value: estimacion.importeSancion,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeBonificacion: {
            value: estimacion.importeBonificacion,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeLiquido: {
            value: estimacion.importeLiquido,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          estatusPago: {
            value: this.getEstatusPagoEstimacion(estimacion.solicitudPago).texto,
            estilo: {
              ...this.estilos.centrado,
            },
          },
          fechaPago: {
            value: this.getEstatusPagoEstimacion(estimacion.solicitudPago).fecha,
            estilo: {
              ...this.estilos.centrado,
            },
          },
        }));
    },
    getEstatusPagoEstimacion(solicitud) {
      // Sin estatus
      if (!solicitud) {
        return {
          texto: 'No pagada',
          fecha: '',
        };
      }

      // Si ya tiene un pago mosrar que ya esta pagado
      if (solicitud.pagosDetalles.length > 0) {
        // Extraer el ultimo pago
        const ultimoPago = solicitud.pagosDetalles[solicitud.pagosDetalles.length - 1];
        return {
          texto: 'Pagado',
          fecha: new Date(ultimoPago.createdAt).toLocaleDateString(),
        };
      }

      // Si no tiene pago mostrar solicitado
      return {
        texto: 'Solicitado',
        fecha: new Date(solicitud.createdAt).toLocaleDateString(),
      };
    },
    cerrar() {
      this.$refs.exportarExcelEstimacionesEjericio.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratosTodos() {
      if (this.contratos.length < 1) return [];
      return this.contratos
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    getContratoFiltrado() {
      if (this.contratos.length < 1) return [];
      const filtrosYearPeriodo = {
        ejercicio: this.filtros.ejercicio,
        periodo: 1,
      };
      if (typeof this.filtros.ejercicio === 'string') {
        const split = this.filtros.ejercicio.split('-');
        filtrosYearPeriodo.ejercicio = Number(split[0]);
        filtrosYearPeriodo.periodo = Number(split[1]);
      } else {
        filtrosYearPeriodo.ejercicio = Number(this.filtros.ejercicio);
      }
      return this.contratos
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Filtrar por ejercicio
        .filter(({ ejercicio, periodo }) => ejercicio === filtrosYearPeriodo.ejercicio
          && periodo === filtrosYearPeriodo.periodo)
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        // Filtro por tipo de estimaciones
        .filter(({ estimaciones }) => {
          if (!this.filtros.tipoEstimacion) return true;

          if (this.filtros.tipoEstimacion === 1) {
            return estimaciones.some(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === true,
            );
          }
          if (this.filtros.tipoEstimacion === 2) {
            if (estimaciones.length <= 0) return false;
            return estimaciones.every(
              ({ esEstimacionFiniquito }) => esEstimacionFiniquito === false,
            );
          }

          return estimaciones.length === 0;
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => ({
          ...contrato,
          cantidadEstimaciones: Number(contrato.estimaciones.length),
        }));
    },
    getContratosParaExcel() {
      return this.seleccion === 'listadoActual' ? this.getContratoFiltrado : this.getContratosTodos;
    },
    getListaContratosEstimaciones() {
      const listaContratosEstimacionesActual = [];
      const listaContratosEstimacionesRangoFechas = [];

      this.getContratosParaExcel.forEach((contrato) => {
        const datos = this.getEstimaciones(contrato);
        listaContratosEstimacionesActual.push(...datos);

        const isBetween = this.$moment(contrato.fecha)
          .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');

        if (isBetween) {
          listaContratosEstimacionesRangoFechas.push(...datos);
        }
      });

      return this.seleccion === 'listadoActual' ? listaContratosEstimacionesActual : listaContratosEstimacionesRangoFechas;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD-MM-YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD-MM-YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: 'ESTIMACIONES POR EJERCICIO',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 27,
          },
        },
      );
      if (this.seleccion === 'rangoFechas') {
        datosDocumento.push(
          {
            value: `${inicial} AL ${final}`,
            row: 2,
            col: 1,
            estilo: {
              font: {
                size: 16,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            combinar: {
              row: 2,
              col: 27,
            },
          },
        );
      }
      return datosDocumento;
    },
    crearExcelEstimacionesEjercicio() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getListaContratosEstimaciones.length > 0
        ? this.getListaContratosEstimaciones : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
